import * as S from "components/common/Banner/Overlay.style";

const OverlayMobile = () => {
  return (
    <S.Overlay>
      <S.TextBanner variant="headline-01" color="white">
        <S.MainInfo>Quem é a CNP Assurances?</S.MainInfo>
      </S.TextBanner>
      <S.TextBanner variant="headline-01" color="white">
        <S.SecondaryInfo>Da França para a vida do brasileiro.</S.SecondaryInfo>
      </S.TextBanner>
      <S.BannerIndicator />
    </S.Overlay>
  );
};

export default OverlayMobile;
